import { type ReactNode } from 'react'
import { Spinner } from './Spinner.js'

export type ButtonVariant = 'primary' | 'action' | 'secondary' | 'ghost' | 'danger'
export type ButtonSize = 'sm' | 'md' | 'lg'

interface Props {
  children?: ReactNode
  variant?: ButtonVariant
  size?: ButtonSize
  disabled?: boolean
  loading?: boolean
  icon?: string
  type?: 'button' | 'submit' | 'reset'
  form?: string
  className?: string
  'aria-label'?: string
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  icon,
  type = 'button',
  form,
  className = '',
  'aria-label': ariaLabel,
  onClick,
}: Props) {
  const cls = [
    'cf-btn',
    `cf-btn--${variant}`,
    `cf-btn--${size}`,
    loading ? 'cf-btn--loading' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button
      type={type}
      form={form}
      className={cls}
      disabled={disabled || loading}
      aria-busy={loading}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      {loading && <Spinner size='sm' />}
      {!loading && icon && (
        <span className='cf-btn__icon' aria-hidden>
          {icon}
        </span>
      )}
      {children && <span className='cf-btn__label'>{children}</span>}
    </button>
  )
}
